import { Button, FlexWrapper, Separator, Text } from '@intigral/shared';
import { StcIcon } from '@intigral/shared/components/SVGIcons/StcIcon';
import { Modal } from '../ui/Modal';
import { __ } from '../../translations';

export type GuestRedirectConfirmModalProps = {
    isOpen: boolean;
    handleCloseModal: () => void;
    onFreeTrialClick?: () => void;
    onSignInClick?: () => void;
};

const GuestRedirectConfirmModal = ({
    isOpen,
    handleCloseModal,
    onFreeTrialClick,
    onSignInClick,
}: GuestRedirectConfirmModalProps) => (
    <Modal
        useFlexLayout={false}
        open={isOpen}
        onOpenChange={() => handleCloseModal()}
        widthSet="medium"
        closeSize="small"
    >
        <FlexWrapper flexDirection="column" gap={{ default: '2x', md: '3x' }}>
            {StcIcon}
            <Text as="h2" variant="h2" margin="0">
                {__('guest_redirect_modal_title')}
            </Text>
            <Text as="p" margin="0" color="gray">
                {__('guest_redirect_modal_description')}
            </Text>
            <Separator theme="bg" margin="0" />
            <FlexWrapper flexDirection="column" itemCount={{ default: 1, md: 2 }} gap={{ default: '2x', md: '3x' }}>
                <Button compact onClick={() => (onFreeTrialClick ? onFreeTrialClick() : handleCloseModal())}>
                    {__('guest_redirect_modal_cta_free_trial')}
                </Button>
                <Button compact secondary onClick={() => (onSignInClick ? onSignInClick() : handleCloseModal())}>
                    {__('guest_redirect_modal_cta_sign_in')}
                </Button>
            </FlexWrapper>
        </FlexWrapper>
    </Modal>
);

export default GuestRedirectConfirmModal;
